import {Formik} from "formik";
import {Button, InputGroup, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import React from "react";
import axios from "axios";
import {useParams} from "react-router-dom";

export function StudentAddToList(props) {
    let { caseid } = useParams();
    return(
        <Formik
            initialValues={{  studentnumber: "",firstname: "",lastname: "",year: "",fulltime: true}}
            onSubmit={(values, { setSubmitting }) => {
                axios.post(  "/api/case/"+caseid+"/addStudent", values).then(res => {
                    setSubmitting(false);
                    props.cb();
                }).catch(err => {
                    alert("Something went wrong, please retry");
                });
            }}
        >
            {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue
                  /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                    <Row>
                        <h5>
                            Add student
                        </h5>
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label>Upload student list CSV</Form.Label>
                            <InputGroup className="mb-3">
                                <span className="input-group-text">Student#:</span>
                                <Form.Control
                                    name="studentnumber"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.studentnumber}
                                />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <span className="input-group-text">Firstname:</span>
                                <Form.Control
                                    name="firstname"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.firstname}
                                />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <span className="input-group-text">Lastname:</span>
                                <Form.Control
                                    name="lastname"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.lastname}
                                />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <span className="input-group-text">Year:</span>
                                <Form.Control
                                    name="year"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.year}
                                />
                            </InputGroup>
                            <Form.Check
                                type="switch"
                                label="Fulltime"
                                name="fulltime"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                checked={values.fulltime}
                            />
                        </Form.Group>
                        <Button type="submit" disabled={isSubmitting} variant="primary" >
                            Add student
                        </Button>
                    </Row>
                </form>
            )}
        </Formik>
    );
}